import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import requestUtils from 'api/requestUtils'
import qs from 'qs'

type PublicPurchaseOffersResponse = paths['/api/lux-loyalty/points/purchase-offers']['get']['responses']['200']['content']['application/json']
type CustomerPurchaseOffersResponse = paths['/api/lux-loyalty/customer/{customerId}/points/purchase-offers']['get']['responses']['200']['content']['application/json']
type PurchaseOffersResponse = PublicPurchaseOffersResponse | CustomerPurchaseOffersResponse
type ServerOffer = PublicPurchaseOffersResponse['result'][number] | CustomerPurchaseOffersResponse['result'][number]

function mapOffer(offer: ServerOffer): App.LoyaltyPurchasePointsOffer {
  return {
    id: offer.id,
    title: offer.title,
    basePrice: offer.basePrice,
    publicPrice: offer.publicPrice,
    currency: offer.currency,
    discountPercent: offer.discountPercent,
    basePoints: offer.basePoints,
    bonusPoints: offer.bonusPoints,
    totalPoints: offer.totalPoints,
    bonusPointsPercent: offer.bonusPointsPercent,
    isEligibleNow: 'isEligibleNow' in offer ? offer.isEligibleNow : undefined,
    nextEligiblePurchaseDate: 'nextEligiblePurchaseDate' in offer ? offer.nextEligiblePurchaseDate ?? undefined : undefined,
  }
}

async function requestLoyaltyPurchasePointsOffers(
  currency: string,
  customerId?: string,
): Promise<Array<App.LoyaltyPurchasePointsOffer>> {
  const path = customerId
    ? `/api/lux-loyalty/customer/${encodeURIComponent(customerId)}/points/purchase-offers`
    : '/api/lux-loyalty/points/purchase-offers'

  const response = await requestUtils.get<PurchaseOffersResponse>(
    `${path}?${qs.stringify({ currency })}`,
    customerId ? { credentials: 'include', excludeBrand: true } : { excludeBrand: true },
  )

  return response.result.map(mapOffer)
}

export default requestLoyaltyPurchasePointsOffers
